module.exports = __webpack_public_path__ + "img/tutorial-thumbnail-02.3f50716b.jpg";